import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            探索分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            从穿搭到美妆，从潮流单品到护肤干货，找到你感兴趣的时尚领域
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 group cursor-pointer text-center"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-400 whitespace-nowrap">
                {cat.count.toLocaleString()}个视频
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}